import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  OperationsPlannerDriverPerformanceCommentDto,
  OperationsPlannerPerformanceResponseDto,
} from "../interfaces/Operations/operationsDriverPerformance";

const performanceEndpoint = `${apiVariable}/getOperationsPlannerDispatcherDriverPerformance`;
const commentEndpoint = `${apiVariable}/setOperationsPlannerDriverPerformanceComment`;

export const fetchOperationsDriverPerformance = async (
  token: string | null | undefined,
  startDate?: string,
  endDate?: string,
): Promise<OperationsPlannerPerformanceResponseDto> => {
  if (!token) {
    throw new Error("Missing authentication token");
  }

  const response = await axios.get<OperationsPlannerPerformanceResponseDto>(
    performanceEndpoint,
    {
      params: { startDate, endDate },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response.data;
};

export const setOperationsDriverPerformanceComment = async (
  token: string | null | undefined,
  payload: OperationsPlannerDriverPerformanceCommentDto,
): Promise<OperationsPlannerDriverPerformanceCommentDto> => {
  if (!token) {
    throw new Error("Missing authentication token");
  }

  const response =
    await axios.post<OperationsPlannerDriverPerformanceCommentDto>(
      commentEndpoint,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

  return response.data;
};
